import * as React from "react";
import { extend } from "lodash";
import { Theme } from "@material-ui/core/styles";
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap,
} from "@material-ui/core/styles/withStyles";
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";
import { APIError } from "~common/lib/types";
import {
  IconButton,
  Button,
  Menu,
  MenuItem,
  ListItemText,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";

import { saveAs } from "file-saver";

import { getValueAtPath } from "~common/form/helper";

import { clone, cloneDeep } from "lodash";

import PortalUserSubscription from "~common/lib/models/portal-user-subscription";

// import SuccessView from '~common/components/success-view';
import LoadingView from "~common/components/loading-view";

import DefinitionSection from "~common/form/definition-section";
import { Definition } from "~common/lib/types";
import { setValueAtPathWithOpts } from "~common/form/helper";
import DashboardCardConfig from "~dashboard/components/dashboard-card-config";
import QueryItemView from "./query-item-view";
import SummaryDialog from "./summary-dialog-form";
import DataExtractDialog from "./data-extract-dialog-form";
import HidableResultsDialog from "./hidable-results-dialog-form";
import TemplateDialog from "./template-renderer";
import Pager from "./query-list-pager";

import ErrorView from "~common/components/error-view";
import SuccessView from "~common/components/success-view";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import CookieManager from "~common/lib/cookie-manager";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    minWidth: 150,
    height: 30,
    padding: 3,
    color: "black",
    "&:focus": {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: theme.palette.common.white,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.black,
      },
    },
  },
}))(MenuItem);

export interface SummaryAction {
  // label is the text that will be displayed in the summary actions drop down
  label: string;

  // form that will be presented to the user if the summary action is selected.  Will be used in favor of the form selector, if provided.
  form: any;

  // formSelector is the form that will be presented to the user if the summary action is selected.
  formSelector: any;

  // allow one to override the props for the compelte button.  `label` will be used as the prop for the button text
  formCompleteButtonProps?: any;

  // allow one to override the props for the cancel button.  `label` will be used as the prop for the button text
  formCancelButtonProps?: any;

  onClick?: Function;

  // onFormComplete is called when the form is completed by the user.
  // `done` is called with the action is complete to dismiss the modal and trigger and update of the results list automatically.
  onFormComplete?: (
    items: Array<any>,
    action: SummaryAction,
    formData: any,
    cancel: boolean,
    done: Function
  ) => void;
}

export interface RowItemAction {
  label: string;
  onClick: Function;
}

const styles = (theme: Theme): StyleRules => {
  let selectionColor = "orange";
  if (
    theme.overrides &&
    theme.overrides.MuiButton &&
    theme.overrides.MuiButton.raisedPrimary &&
    theme.overrides.MuiButton.raisedPrimary.backgroundColor
  ) {
    selectionColor = theme.overrides.MuiButton.raisedPrimary.backgroundColor;
  }

  return {
    hover: {
      "&:hover": {
        backgroundColor: "#dcdbdc",
        border: "solid #b8b8b8 1px",
      },
      border: "solid #ffffff 1px",
    },
    container: {
      width: "100%",
    },
    listFunctionLine: {
      display: "flex",
      justifyContent: "space-between",
    },
    addNewRow: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    addNewRowNoResults: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 15,
    },
    listTitle: {
      marginBottom: 10,
    },
    sectionTitle: {
      // fontSize: "0.9rem",
      marginBottom: 10,
      fontSize: "1.3125rem",
      fontWeight: 500,
      fontFamily: "Roboto,Arial,sans-serif",
      lineHeight: "1.16667em",
      paddingLeft: 8,
    },
    listFunctions: {
      display: "flex",
      justifyContent: "flex-end",
    },
    listFunctionButton: {
      color: "#8d8d8d",
      fontSize: "1.0rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    listFunctionButtonIcon: {
      minWidth: "1.0rem",
    },
    criteriaSection: {
      padding: 10,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    paper: {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    resultsSection: {
      padding: 10,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    noResultsSection: {
      padding: 30,
      paddingBottom: 15,
      boxShadow: "0px 0px 0px #FFFFFF;none",
      display: "flex",
      justifyContent: "center",
    },
    // An alternate to the above used when returning multiples
    resultsListSection: {
      padding: 10,
      marginTop: 15,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    pagerArea: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    pager: {},
    evenRow: {
      backgroundColor: "#fff",
      padding: "10px 5px 5px 5px",
      borderBottom: "1px solid #ccc",
    },
    oddRow: {
      backgroundColor: "#f0f0f0",
      padding: "10px 5px 5px 5px",
      borderBottom: "1px solid #ccc",
    },
    clickableRow: {
      cursor: "pointer",
    },
    buttonBar: {
      display: "flex",
      justifyContent: "space-between",
      spaceBetween: 15,
      padding: 15,
      paddingBottom: 0,
    },
    addBar: {
      display: "flex",
      justifyContent: "flex-start",
      paddingBottom: 0,
    },
    sortArea: {
      justifyContent: "flex-start",
      alignItems: "center",
      minHeight: 50,
    },
    sortOptions: {
      maxWidth: 300,
      minWidth: 150,
      marginRight: 30,
    },
    sortOptionIcon: {
      marginLeft: 5,
    },
    buttonArea: {
      marginTop: 15,
      justifyContent: "flex-end",
      minHeight: 50,
    },
    buttonSubmit: {
      marginLeft: 15,
    },
    buttonAddNew: {
      marginLeft: 15,
      marginRight: 15,
      justifyContent: "flex-end",
    },
    buttonCancel: {
      paddingLeft: 15,
    },
    noResultsText: {
      display: "flex",
      justifyContent: "center",
      paddingLeft: 15,
    },
    simulationWarning: {
      border: "1px solid #fdde00",
      backgroundColor: "#fffedc",
      padding: 15,
      marginBottom: 15,
      textAlign: "center",
    },
    selectedRow: {
      border: "1px solid " + selectionColor,
      margin: 1,
    },
    summaryActionPolicyMessages: {
      border: "2px solid red",
      margin: 1,
    },
    unselectedRow: {
      border: "1px solid rgba(255,255,255,0.0)",
      margin: 1,
    },
    selectionActionArea: {
      display: "flex",
      justifyContent: "space-between",
      textAlign: "right",
      paddingLeft: 6,
      paddingRight: 5,
      paddingBottom: 5,
      verticalAlign: "baseline",
      minHeight: 45,
      marginBottom: 5,
    },
    selectionCount: {
      display: "inline-block",
      width: "40%",
      textAlign: "center",
      paddingTop: 10,
    },
    selectionAction: {
      display: "inline-block",
      width: "30%",
    },
    allSelectors: {
      display: "inline-block",
      width: "30%",
      color: "#333",
      textAlign: "left",
      paddingTop: 10,
    },
    selector: {
      color: selectionColor,
    },
    select: {
      color: selectionColor,
      display: "inline-block",
      cursor: "pointer",
    },
    unselect: {
      color: selectionColor,
      display: "inline-block",
      marginLeft: 15,
      cursor: "pointer",
    },
    summaryActionMessage: {
      fontWeight: 600,
      paddingBottom: 10,
      color: selectionColor,
      fontStyle: "italic",
    },
  };
};

interface ButtonProps {
  label?: any;
  variant?: any;
  color?: any;
}

// tag::query_fulfillment_props[]
interface Props extends React.HTMLProps<HTMLDivElement> {
  history?: any;
  // Match supports parameters, although at this point, parameters are manager by URL Manager
  match?: any;
  // Classes can be passed in to control look and feel, such as `evenRow` and `oddRow`
  classes: any;
  // The URL to be used when selecting forms
  formSelectorUrl?: string;
  // The URL to be used when performing the query
  queryUrl?: string;
  // If necessary, data fulfillment can also be handled by the parent.
  queryFn?: Function;
  // The timeout to allow for fulfillment.  This can be useful in long running transactions.
  queryTimeoutSec?: number;
  // Indicates that when criteria are on the URL when the page is loaded, the query will automatically be executed.
  autoQuery?: boolean;

  //Signals that this form allows for adding new items. Adds a 'Add New' button that directs the user to the provided URL
  addNewUrl?: string;

  // Indicates that when first loading a page, a search will be executed regardless of empty criteria.
  // TODO: Possibly move this into core.
  forceExecuteOnLoad?: boolean;
  // The criteria form is the form that is used to collect the criteria
  alwaysExecuteOnSubmit?: boolean;

  // Custom Renderers to be used in the criteria AND results forms
  customRenderers?: any;

  // Custom messages to be provided to the criteria AND results forms
  customMessages?: any;

  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  // The criteria form.  Either this or a valid selector must be provided
  criteriaForm?: any;
  // The criteria form selector.  Either this or a valid form must be provided
  criteriaFormSelector?: any;
  // Determines whether the outbound form will be pruned of options and other unnecessary information that
  pruneCriteriaForm?: boolean;

  // This function, if passed, is called when the critieria form is renders, allows client-land tweeks
  onCriteriaFormSelection?: Function;

  // onEvaluateConditional is called when the form conditionals are evaluated.
  onEvaluateConditional?: Function;

  // hide criteria
  suppressCriteriaView?: boolean;

  resultsForm?: any;
  // The results form selector.  Either this, a valid form, or results columns (only supported in `table` mode) must be provided
  resultsFormSelector?: any;
  // The columns to be displayed in the grid, which is rendered only when the mode is `table`
  resultsColumns?: boolean;
  // The function to be called when the row is clicked.
  onRowClick?: Function;
  // The array of actions to be made available for each row.

  actionsForSelectedItems?: Function;
  // signals that the selection should be enabled.  This function will be called

  // This will be called when the summaryFunction is clicked instead of the internal function
  // handleSummaryMenuClick?: Function
  summaryActionMessage?: string;

  actionsForItemRow?: Function;

  // Reserves the layout space for row actions regardless of whether row actions are available.
  // This help when trying to keep row with and without actions alinged.
  reserveRowActionSpace?: boolean;
  // The text for the clear button
  clearButtonText?: string;
  // The text for the submit button
  submitButtonText?: string;
  // A set of props to control the appearance of the submit button
  submitButtonProps?: ButtonProps;
  // A set of props to control the appearance of the cancel button
  cancelButtonProps?: ButtonProps;
  // The variant to use.  Defaults to `normal`
  variant?: "normal" | "single" | "table";
  // The text to be displayed the query is sucessful, but no results are returned.
  noResultsText?: string;
  // The function to get noResultsText, if provided will be used ahead of the noResultsText prop.
  getNoResultsText?: any;
  // The starting page size.
  pageSize?: number;

  // Fields that will be excluded from being cleared then the Criteria Clear button is clicked.
  excludeFromClear?: Array<string>;

  // don't show status icon at begining of section title
  supressSectionStatusIcon?: boolean;

  // Allow the caller to suppress the use of the URL manager
  suppressURL?: boolean;
  // By default, only when the criteria changed and the submit is initiated that the query is executed.
  // This setting allows you to indicate that the query should always be executed, even if the criteria has not changed.

  suppressExport?: boolean;

  suppressDashboardCard?: boolean;

  // if an export to a different format is needed, provide the exportContentType.  This is the content type that will be passed back to the fulfillment handler.
  exportContentType?: string;
  // The results form.  Either this or a valid selector must be provided

  suppressTitle?: boolean;

  // Strings passed to the definition section that will replace the title in the form definition
  criteriaTitleOverride?: string;
  resultsTitleOverride?: string;

  // In some cases, you may not want the user to be able to collapse sections
  preventCollapse?: boolean;

  // Indicates wheterh a subscription should be allowed for this query
  allowSubscription?: boolean;

  summaryRenderer?: any;

  // Hide scroll top
  disallowScrollTop?: boolean

  // handleCriteriaChange
  handleCriteriaChange?: (path: string, data: any) => any;
}
// end::query_fulfillment_props[]
//
//

interface SummaryOperation {
  action: SummaryAction;
  items: Array<any>;
}

type State = {
  status:
    | "loading"
    | "invalid"
    | "searching"
    | "paging"
    | "ready"
    | "error"
    | "fatal";
  criteria: any;
  currentPage: number;
  pageSize: number;
  error?: APIError;
  success?: string;
  // The is the criteria form that was either passed in or looked up using the
  criteriaForm?: any;
  resultsForm?: any;
  extractionDefinition?: any;
  hidableResultsOpen?: boolean;
  resultsColumns?: any;
  results?: any;
  sortOption?: any;
  submitButtonProps: ButtonProps;
  cancelButtonProps: ButtonProps;
  dashboardConfig: any;
  subscriptionConfig: any;
  hasExecutedQuery: boolean;
  loadingExport?: boolean;
  // summary handling
  summaryMenuAnchorEl: any;
  summaryMenuOpen: boolean;
  // When this is not falsy, we are acting on the items with the action reflected in the operation
  summaryOperation?: SummaryOperation;
  templateRenderer?: any;
};

class QueryList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props) {
    super(props, {});

    this.submitRef = React.createRef();

    var submitButtonProps: ButtonProps = {
      label: "Submit",
      variant: "raised",
      color: "primary",
    };

    var cancelButtonProps: ButtonProps = {
      label: "Cancel",
      variant: "raised",
      color: "primary",
    };

    if (
      props.hasOwnProperty("submitButtonProps") &&
      props["submitButtonProps"]
    ) {
      extend(submitButtonProps, props["submitButtonProps"]);
    }

    if (
      props.hasOwnProperty("cancelButtonProps") &&
      props["cancelButtonProps"]
    ) {
      extend(cancelButtonProps, props["cancelButtonProps"]);
    }

    // check for pageSize cookie
    var pageSize: any;
    var ps = CookieManager.getCookie(
      `queryListPageSize|${window.location.pathname}`
    );
    if (ps != "") {
      pageSize = Number(ps);
      if (isNaN(pageSize)) {
        pageSize = undefined;
      }
    }
    // this.onFormSubmit = this.onFormSubmit.bind(this);

    this.state = {
      status: "loading",
      hasExecutedQuery: false,
      criteria: {},
      dashboardConfig: null,
      subscriptionConfig: null,
      // Paging defaults
      currentPage: 0,
      pageSize: pageSize || props.pageSize || 10,
      submitButtonProps: submitButtonProps,
      cancelButtonProps: cancelButtonProps,
      summaryMenuOpen: false,
      summaryMenuAnchorEl: null,
    };
  }

  componentDidMount() {
    var { autoQuery, forceExecuteOnLoad } = this.props;

    this.handleProps(this.props, autoQuery ? true : false, forceExecuteOnLoad);

    if (!this.props.suppressURL) {
      URLManager.addOnChangeHandler((newVal: any) => {
        this.executeQuery();
      });
    }
  }

  UNSAFE_componentWillReceiveProps(newProps: any) {
    this.handleProps(newProps, false);
  }

  handleProps(props: any, autoQuery: boolean, forceExecuteOnLoad?: boolean) {
    var {
      criteriaForm,
      criteriaFormSelector,
      resultsForm,
      resultsFormSelector,
      resultsColumns,
    } = props;

    var promises: Array<any> = [];
    var cfIdx = -1;
    var rfIdx = -1;

    if (!criteriaForm && criteriaFormSelector) {
      cfIdx = promises.length;
      promises.push(
        request.get(
          "/api/form-definitions/select?selector=" +
            URLManager.getQueryStringValue(criteriaFormSelector)
        )
      );
    }

    if (!resultsForm && resultsFormSelector) {
      rfIdx = promises.length;
      promises.push(
        request.get(
          "/api/form-definitions/select?selector=" +
            URLManager.getQueryStringValue(resultsFormSelector)
        )
      );
    }

    if (promises.length > 0) {
      Promise.all(promises)
        .then((values) => {
          var crit: any;

          if (!this.props.suppressURL) {
            crit = URLManager.getQueryString() || {};
          } else {
            crit = this.state.criteria;
          }

          var newState: State = this.state;

          (newState.status = "ready"), (newState.criteriaForm = criteriaForm);
          newState.resultsForm = resultsForm;
          newState.resultsColumns = resultsColumns;
          newState.criteria = crit;

          if (crit.sortBy && criteriaForm && criteriaForm.sortOptions) {
            newState.sortOption = criteriaForm.sortOptions.find(function (
              opts
            ) {
              return (
                opts.sortBy == crit.sortBy &&
                opts.sortDirection == crit.sortDirection
              );
            });
          }

          if (cfIdx > -1) {
            if (!values[cfIdx].body) {
              const apiErr = new APIError();
              apiErr.type = "http";
              apiErr.message = "Invalid Criteria Form Definition";
              apiErr.details = "";
              this.setState({
                status: "error",
                error: apiErr,
              });
              return;
            } else {
              newState.criteriaForm = new Definition(values[cfIdx].body);
            }
          } else {
            newState.criteriaForm = new Definition(criteriaForm);
          }

          // This is the point that, if the user has passed a function on onCriteriaFormSelection, we should call it, transforming the form by reference
          if (this.props.onCriteriaFormSelection) {
            this.props.onCriteriaFormSelection(newState.criteriaForm);
          }

          if (rfIdx > -1) {
            if (!values[rfIdx].body) {
              const apiErr = new APIError();
              apiErr.type = "http";
              apiErr.message = "Invalid Results Form Definition";
              apiErr.details = "";
              this.setState({
                status: "error",
                error: apiErr,
              });
              return;
            } else {
              newState.resultsForm = new Definition(values[rfIdx].body);
            }
          } else {
            newState.resultsForm = new Definition(resultsForm);
          }

          if (
            !newState.criteriaForm ||
            (!newState.resultsColumns && !newState.resultsForm)
          ) {
            const apiErr: any = new APIError(
              "http",
              "Invalid Form Configuration",
              JSON.stringify(criteriaFormSelector, null, "  ")
            );
            this.setState({
              status: "error",
              error: apiErr,
            });
            return;
          }

          //
          if (!values[cfIdx].body) {
            const apiErr: any = new APIError(
              "http",
              "Invalid Form Definition",
              JSON.stringify(resultsFormSelector, null, "  ")
            );
            this.setState({
              status: "error",
              error: apiErr,
            });
            return;
          }

          if (
            newState.criteriaForm &&
            newState.resultsForm &&
            newState.resultsForm.sortOptions
          ) {
            newState.criteriaForm.sortOptions =
              newState.resultsForm.sortOptions;
          }

          this.setState(newState, () => {
            // If we have criteria and they are now set on the state, so fire at will.
            if (
              forceExecuteOnLoad ||
              (autoQuery && Object.keys(crit).length > 0)
            ) {
              this.executeQuery();
            }
          });
        })
        .catch((err) => {
          const apiErr = new APIError();
          apiErr.type = "http";
          apiErr.message = "Error fetching data during initialization";
          apiErr.details = (err.response || { text: err.toString() }).text;
          this.setState({
            status: "error",
            error: apiErr,
          });
        });
    } else {
      if (!criteriaForm || (!resultsColumns && !resultsForm)) {
        const apiErr = new APIError(
          "http",
          "Invalid Form configuration",
          JSON.stringify(resultsFormSelector, null, "  ")
        );
        this.setState({
          status: "error",
          error: apiErr,
        });
        return;
      } else {
        var crit: any;

        if (!this.props.suppressURL) {
          crit = URLManager.getQueryString() || {};
        } else {
          crit = this.state.criteria || {};
        }

        this.setState(
          {
            status: "ready",
            criteriaForm: new Definition(criteriaForm),
            resultsForm: new Definition(resultsForm),
            resultsColumns: resultsColumns,
            criteria: crit,
          },
          () => {
            // If we have criteria and they are now set on the state, so fire at will.
            if (
              forceExecuteOnLoad ||
              (autoQuery && Object.keys(crit).length > 0)
            ) {
              this.executeQuery();
            }
          }
        );
      }
    }
  }

  handleSubmit = (event: any) => {
    const { criteria } = this.state;
    // const submitButton = this.submitRef;
    // submitButton.focus()
    document.getElementById("submitButton").focus();
    if ((event.detail || 1) == 1) {
      setTimeout(() => {
        if (this.props.alwaysExecuteOnSubmit) {
          // If we are always going to execute, we will set the URL amanger silently and trigger manually.
          this.executeQuery(criteria);

          if (!this.props.suppressURL) {
            var crit = clone(criteria);

            // We need to delete these since we do not need them on the URL and their length blows out the NGINX URL max length default setting
            delete crit.criteriaForm;
            delete crit.resultsForm;

            URLManager.putQueryString(crit, true);
          }
        } else {
          // Otherwise we will report the value and let the URL manager decide whether to report a change.
          if (!this.props.suppressURL) {
            var crit = clone(criteria);

            // We need to delete these since we do not need them on the URL and their length blows out the NGINX URL max length default setting
            delete crit.criteriaForm;
            delete crit.resultsForm;

            URLManager.putQueryString(crit);
          }
        }
      }, 100);
    }
  };

  handleReset = () => {
    this.setState({ results: null });
  };

  refreshQueryResults = (policyMessages: any) => {
    const { criteria } = this.state;
    this.executeQuery(criteria, false, policyMessages);
  };

  executeQuery = (
    crit?: any,
    newPage?: boolean,
    refreshWithPolicyMessages?: any
  ) => {
    this.setState(
      {
        error: undefined,
      },
      () => {
        const { queryUrl, queryFn, queryTimeoutSec, pruneCriteriaForm } =
          this.props;
        const { criteria, criteriaForm, resultsForm, pageSize } = this.state;
        var { currentPage } = this.state;

        if (!newPage) {
          currentPage = 0;
        }

        if (!crit) {
          crit = criteria;
        }

        // If we are executing the query in this fashion, we will need to ensure that the extraction opts do not leak in
        crit.extractionOpts = {};

        // Just before we execute the query, we need to trim out the aggregationOpts
        // This is in case the dashboard editor has left the criteria.aggregationOpts
        // Query List, at this point, never expects to issue aggregation queries.
        criteria.aggregationOpts = null;

        // The form is also part of the criteria, so make sure to set that as well.
        // This is used on the server to do server-side form validations.
        let cf = cloneDeep(criteriaForm);

        if (pruneCriteriaForm) {
          cf.predefined = cf.predefined.map((field) => {
            if (field.options) {
              field.options = [];
            }
            return field;
          });
        }

        crit.criteriaForm = cf;

        crit.resultsForm = resultsForm;

        // Add in the paging information, in addition to the criteria provided by users.
        crit.skip = currentPage * pageSize;
        crit.limit = pageSize;

        var completionTimeout = 600000;
        var responseTimeout = 300000;

        if (queryTimeoutSec) {
          completionTimeout = queryTimeoutSec * 1000;
          responseTimeout = queryTimeoutSec * 1000;
        }

        if (queryFn) {
          var response: any = queryFn(crit);
          this.setState({
            results: response,
            status: "ready",
            hasExecutedQuery: true,
            currentPage: currentPage,
          });
        } else {
          this.setState(
            {
              status: newPage ? "paging" : "searching",
              currentPage: currentPage,
            },
            () => {
              request
                .post(queryUrl || "")
                .send(crit)
                .timeout({
                  response: responseTimeout,
                  deadline: completionTimeout,
                })
                .then((response) => {
                  if (response.body) {
                    // REVIEW:  hasExecutedQuery should be true, the query has run and in some cases items comes back null
                    if (
                      response.body.policyMessages &&
                      response.body.policyMessages.length > 0
                    ) {
                      const apiErr = new APIError(
                        "http",
                        "One or more errors has occurred.",
                        JSON.stringify(response.body.policyMessages, null, "  ")
                      );
                      this.setState({
                        error: apiErr,
                        status: "ready",
                        hasExecutedQuery: false,
                        results: response.body,
                      });
                    } else {
                      // If refreshWithPolicyMessages was passed in as a result of a refresh, enumerate them and add accordingly
                      var data: any = response.body;
                      if (
                        refreshWithPolicyMessages != null &&
                        refreshWithPolicyMessages.policyMessages != null &&
                        refreshWithPolicyMessages.appendField != null &&
                        refreshWithPolicyMessages.fieldMatcher != null &&
                        refreshWithPolicyMessages.appendDelimiter != null
                      ) {
                        if (data && data.items) {
                          data.items.forEach((i) => {
                            refreshWithPolicyMessages.policyMessages.forEach(
                              (pm) => {
                                if (
                                  pm.policyEntityID ==
                                  i[refreshWithPolicyMessages.fieldMatcher]
                                ) {
                                  if (!i["_SummaryActionPolicyMessages"]) {
                                    i["_SummaryActionPolicyMessages"] = [];
                                  }
                                  i["_SummaryActionPolicyMessages"].push(pm);
                                  i[refreshWithPolicyMessages.appendField] =
                                    pm.title +
                                    (i[refreshWithPolicyMessages.appendField] !=
                                    null
                                      ? (refreshWithPolicyMessages.appendDelimiter ||
                                          "|") +
                                        i[refreshWithPolicyMessages.appendField]
                                      : "");
                                }
                              }
                            );
                          });
                        }
                      }
                      this.setState({
                        results: data,
                        status: "ready",
                        hasExecutedQuery: response.body.items ? true : true,
                      });
                    }
                  } else {
                    const apiErr = new APIError(
                      "http",
                      "Empty response body returned",
                      JSON.stringify(crit, null, "  ")
                    );
                    this.setState({ error: apiErr, status: "ready" });
                  }
                })
                .catch((err) => {
                  const apiErr = new APIError();
                  apiErr.type = "http";
                  apiErr.message = (
                    err.response || { text: err.toString() }
                  ).text;
                  this.setState({
                    status: "ready",
                    results: [],
                    error: apiErr,
                  });
                });
            }
          );
        }
      }
    );
  };

  handleAccessRootData = (fullPath: string): any => {
    const { criteria } = this.state;
    // If the call has a conditional call that first, honoring the stopEvaluation as necessary

    var evalVal: any;

    if (fullPath.indexOf("~/") == 0) {
      // Since this is something that we are only evaluating here (_new) we will stop evaluation when we are done.
      fullPath = fullPath.replace(/^~/, "");

      evalVal = getValueAtPath(fullPath, criteria);
    }

    return evalVal;
  };

  exportList = (contentType: string) => (evt: any) => {
    const { queryUrl, queryTimeoutSec } = this.props;
    const { criteria, resultsForm, currentPage, pageSize } = this.state;

    // This is to prevent side effects from being exposed to other areas of the application.
    const crit = cloneDeep(criteria);

    // The form is also part of the criteria, so make sure to set that as well.
    // This is used on the server to do server-side form validations.
    //crit.criteriaForm = criteriaForm;
    crit.resultsForm = resultsForm;

    // Add in the paging information, in addition to the criteria provided by users.
    crit.skip = currentPage * pageSize;
    crit.limit = pageSize;

    var completionTimeout = 600000;

    if (queryTimeoutSec) {
      completionTimeout = queryTimeoutSec * 1000;
    }

    this.setState({ loadingExport: true });

    request
      .post(queryUrl || "")
      .set("Content-Type", "application/json")
      .send(JSON.stringify(crit))
      .set("Accept", contentType)
      .responseType("blob")
      .timeout({
        response: 600000,
        deadline: completionTimeout,
      })
      .then((response) => {
        let filename = crit.resultsForm.key + ".xlsx";

        let disposition = response["headers"]["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        // file saver module allows blob downloads for IE10+
        saveAs(response.body, filename);
      })
      .catch((err) => {
        const apiErr = new APIError();
        apiErr.type = "http";
        apiErr.message = (err.response || { text: err.toString() }).text;
        this.setState({ error: apiErr, status: "error" });
      })
      .then(() => {
        this.setState({ loadingExport: false });
      });
  };

  handleSubscribeClick = () => {
    var self = this;
    const { history } = this.props;

    if (!history) {
      console.error(
        "When enabling subscription functionality by passing `subscriptionUrl`, you must also provide `history`."
      );
      return;
    }

    var { resultsForm } = this.state;

    var excelColumns = new Array<any>();
    var columnData = new Array<any>();

    if (resultsForm.predefined) {
      for (const f of resultsForm.predefined) {
        excelColumns.push({
          headerText: f.title,
          attributeName: f.key,
        });
        columnData.push({
          label: f.title,
          id: f.key,
          numeric:
            f.type == "Numeric" || f.type == "Currency" || f.type == "Number"
              ? true
              : false,
        });
      }
    }

    // create a Subscription token and then redirect to the subscription edit view in the root.
    const portalSub = new PortalUserSubscription({
      dataURL:
        this.props.queryUrl +
        `?q=${URLManager.getQueryStringValue(this.state.criteria)}`,
      extendedAttributes: {
        columns: columnData,
        excelColumns: excelColumns,
      },
    });

    portalSub
      .save()
      .then((sub: PortalUserSubscription) => {
        window.location.href =
          "/subscriptions/" +
          sub.id.toString() +
          "?return=" +
          encodeURI(window.location.href);
      })
      .catch((err: APIError) => {
        self.setState({
          error: err,
        });
      });
  };

  addToDashboard = (evt: any) => {
    const { queryUrl } = this.props;
    const { criteria, criteriaForm, resultsForm, currentPage, pageSize } =
      this.state;

    const crit = criteria;

    // The form is also part of the criteria, so make sure to set that as well.
    // This is used on the server to do server-side form validations.
    // Add in the paging information, in addition to the criteria provided by users.
    crit.skip = currentPage * pageSize;
    crit.limit = pageSize;

    const elementConfig = {
      //config defaults
      title: "",
      elementType: "count",
      layoutAttributes: {
        lg: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        md: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        sm: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        xl: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        xs: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
      },
      fulfillmentUrl: queryUrl,
      fulfillmentCriteria: crit,
      criteriaForm: criteriaForm,
      resultsForm: resultsForm,
    };

    this.setState({ dashboardConfig: elementConfig });
  };

  handleFunctionDialogClose = (evt: any) => {
    this.setState({ dashboardConfig: null, error: null });
  };

  handleChangeAtPath = (path: string, value: any) => {
    const fn = () => {
      var { criteria } = this.state;

      let { data, err } = setValueAtPathWithOpts(path, criteria, value, {
        emptyAsNull: true,
      });

      if (this.props.handleCriteriaChange) {
        data = this.props.handleCriteriaChange(path, data);
      }

      if (err) {
        const apiErr = new APIError();
        apiErr.message = err;
        this.setState({
          error: apiErr,
        });
      } else {
        this.setState({
          criteria: data,
        });
      }
    };

    if (this.state.error) {
      this.setState(
        {
          error: null,
        },
        () => {
          fn();
        }
      );
    } else {
      fn();
    }
  };

  handleClearClick = () => {
    var { criteria } = this.state;
    // in case criteria is null
    criteria = criteria || {};

    var crit = {};

    var { excludeFromClear } = this.props;

    // check if fields have been excluded from being cleared.
    if (excludeFromClear && excludeFromClear.length > 0) {
      // loop over excluded fields
      excludeFromClear.forEach((c) => {
        if (criteria[c]) {
          // field exists on top-level object
          crit[c] = criteria[c];
        } else {
          // field doesn't exist on top level object
          // check to see if field is nested.
          Object.keys(criteria).forEach((k) => {
            if (typeof criteria[k] === "object") {
              if (criteria[k] && criteria[k][c]) {
                if (!crit[k]) {
                  crit[k] = {};
                }
                crit[k][c] = criteria[k][c];
              }
            }
          });
        }
      });
    }

    this.setState({
      error: undefined,
      criteria: crit,
      sortOption: null,
      hasExecutedQuery: false,
      results: undefined,
    });
  };

  handleRowClick = (row: any) => () => {
    if (this.props.onRowClick) {
      this.props.onRowClick.call(this, row);
    }
  };

  handleChangePage = (newPage: number, newPageSize: number) => {
    const { pageSize } = this.state;
    if (pageSize != newPageSize) {
      // if the page size is changed, go back to page 1
      newPage = 0;
    }

    this.setState({ currentPage: newPage, pageSize: newPageSize }, () => {
      // save pageSize to cookie

      CookieManager.setCookie(
        `queryListPageSize|${window.location.pathname}`,
        String(newPageSize),
        30
      );

      // Make sure and update the URL, even though we will manually trigger the execute manually by passing true as the  `silent`
      if (!this.props.suppressURL) {
        let criteria = this.state.criteria;
        delete criteria.criteriaForm;
        delete criteria.resultsForm;
        URLManager.putQueryString(criteria, true);
      }
      this.executeQuery(null, true);
    });
  };

  onErrorClose = () => {
    // This causes fields to be reset once fired
    // this.setState({
    //   error: undefined
    // });
  };

  onSortChange = (evt: any) => {
    const { criteria } = this.state;

    var so: any;
    if (evt.target.value) {
      let v = JSON.parse(atob(evt.target.value));
      const so = v;
      criteria.sortBy = so.sortByKey;
      criteria.sortDirection = so.sortDirection;
    } else {
      criteria.sortBy = null;
      criteria.sortDirection = null;
    }

    this.setState({ criteria: criteria, sortOption: evt.target.value }, () => {
      // Make sure and update the URL, even though we will manually trigger the execute manually by passing true as the  `silent`
      if (!this.props.suppressURL) {
        delete criteria.criteriaForm;
        delete criteria.resultsForm;
        URLManager.putQueryString(this.state.criteria, true);
      } else {
        this.executeQuery(criteria);
      }
    });
  };

  /*******************************************************************************************
   *
   *                                Dashboard Card Management
   *
   *******************************************************************************************/

  handleCardDialogClose = () => {
    this.setState({ dashboardConfig: null, error: null });
  };

  handleCardDialogComplete = () => {
    const { dashboardConfig, criteria, criteriaForm, resultsForm } = this.state;
    this.setState({ error: null }, () => {
      // Reshape this here or do it server side.  We just need to make sure and provide the queryUrl, queryCriteria, etc.
      const e: any = {
        scope: "Private",
        title: dashboardConfig.title,
        elementType: dashboardConfig.elementType,
        fulfillmentURL: this.props.queryUrl,
        fulfillmentCriteria: criteria,
        criteriaForm: criteriaForm,
        resultsForm: resultsForm,
      };

      // Set the targetURL for the reuslts handler
      dashboardConfig.targetURL = window.location.pathname;

      // clean up the data that we do not need to embed into the elementAttributes
      var alteredDashboardConfig = cloneDeep(dashboardConfig);
      delete alteredDashboardConfig.criteria;
      delete alteredDashboardConfig.scope;
      delete alteredDashboardConfig.elementType;
      delete alteredDashboardConfig.queryUrl;
      delete alteredDashboardConfig.type;
      delete alteredDashboardConfig.title;

      e.elementAttributes = alteredDashboardConfig;

      request
        .post("/api/dashboards")
        .set("Content-Type", "application/json")
        .send(JSON.stringify(e))
        .then((response) => {
          // Show the SuccessView
          if (
            response.body &&
            response.body.policyMessages &&
            response.body.policyMessages.length > 0
          ) {
            const apiErr = new APIError(
              "http",
              "One or more errors has occurred.",
              JSON.stringify(response.body.policyMessages, null, "  ")
            );
            this.setState({
              error: apiErr,
              status: "ready",
              hasExecutedQuery: false,
              results: response.body,
            });
          } else {
            this.setState({
              success: "Card Successfully Added",
              dashboardConfig: null,
              error: null,
            });
          }
        })
        .catch((err) => {
          const apiErr = new APIError();
          apiErr.type = "http";
          apiErr.message = (err.response || { text: err.toString() }).text;
          this.setState({ error: apiErr, status: "error" });
        });
    });

    //
  };

  handleDashboardConfigChange = (config: any, complete: boolean) => {
    this.setState({ dashboardConfig: config });
  };

  handleAddNew = (addNewUrl: string) => {
    window.location.href = this.props.addNewUrl;
  };

  renderDashboardCardDialog = () => {
    const { classes }: { classes: ClassNameMap } = this.props;
    // configElement and configElementType need to be added to state and managed
    const {
      dashboardConfig,
      elementTypes,
      configElement,
      configElementType,
      results,
    } = this.state;

    if (!dashboardConfig) {
      return null;
    }

    // This is only for temporary backward compatibility
    const configView = (
      <DashboardCardConfig
        onConfigChange={this.handleDashboardConfigChange}
        config={dashboardConfig}
        results={results}
      />
    );

    return (
      <Dialog
        className={classes.modal}
        open={true}
        onClose={this.handleFunctionDialogClose}
      >
        <DialogTitle>Add to Dashboard</DialogTitle>
        <DialogContent
          style={{ minHeight: 300, minWidth: 300 }}
          className={classes.modalContent}
        >
          <div>{configView}</div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={this.handleCardDialogClose}
            color="default"
          >
            Cancel
          </Button>
          <Button
            autoFocus={true}
            onClick={this.handleCardDialogComplete}
            variant="contained"
            color="secondary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  onSuccessViewClose = () => {
    this.setState({
      success: undefined,
    });
  };

  onFormSubmit = (evt: any) => {
    evt.nativeEvent.preventDefault();
    evt.stopPropagation();

    return false;
  };

  /*******************************************************************************************
   *
   *                               Summary Actions Handling
   *
   *******************************************************************************************/

  onSelectedItemChange = (item: any, selected: boolean) => {
    item["_selected"] = selected;
    this.forceUpdate();
  };

  handleSummaryMenuClick = (event) => {
    this.setState({
      summaryMenuAnchorEl: event.currentTarget,
      summaryMenuOpen: !this.state.summaryMenuOpen,
    });
  };

  handleSummaryMenuClose = () => {
    this.setState({ summaryMenuAnchorEl: null, summaryMenuOpen: false });
  };

  handleSummaryMenuItemClick = (action) => () => {
    const { results } = this.state;

    if (
      results &&
      results.items &&
      results.items.reduce &&
      results.items.length > 0
    ) {
      const selectedItems = results.items.reduce((acc: Array<any>, i: any) => {
        if (i["_selected"]) {
          acc.push(i);
        }
        return acc;
      }, []);

      this.setState(
        {
          summaryMenuAnchorEl: null,
          summaryMenuOpen: false,
          summaryOperation: { action: action, items: selectedItems },
        },
        () => {
          if (action.onClick) {
            this.setState({
              templateRenderer: (
                <TemplateDialog
                  title="Loading..."
                  data={{
                    count: selectedItems.length,
                    selectedItems: selectedItems,
                  }}
                  templateSelector={action.templateSelector}
                  completeButtonText="Continue"
                  handleCancel={() => {
                    this.setState({
                      templateRenderer: null,
                    });
                  }}
                  handleComplete={() => {
                    this.setState(
                      {
                        templateRenderer: null,
                        status: "loading",
                        loadingText: "Performing Summary Action...",
                      },
                      () => {
                        action.onClick(selectedItems, this.refreshQueryResults);
                      }
                    );
                  }}
                />
              ),
            });
          }
        }
      );
    } else {
      this.setState({ summaryMenuAnchorEl: null, summaryMenuOpen: false });
    }
  };

  handleSummarySelectAllClick = () => {
    const { results } = this.state;
    results.items = results.items.map((i) => {
      i["_selected"] = true;
      return i;
    });
    this.setState({ results });
  };

  handleSummaryUnselectAllClick = () => {
    const { results } = this.state;
    results.items = results.items.map((i) => {
      delete i["_selected"];
      return i;
    });
    this.setState({ results });
  };

  handleSummaryOpComplete = (
    items: Array<any>,
    action: SummaryAction,
    formData: any,
    cancelled: boolean
  ): void => {
    // The summary dialog will not manage internal display state, so if we do not want this rendered we should set the summary operation.
    // To close the dialog, set the summaryOperation to null so the stops rendering.
    //
    // For now, we will just do
    this.setState({ summaryOperation: undefined });
  };

  /*********************************************************************************************
   *
   *                          Data Extraction Actions Handling
   *
   * ******************************************************************************************/

  // extractData sets the extractionAttributes which are then used to extract data from the results

  extractData = (contentType: string) => (evt: any) => {
    const { results } = this.state;

    if (
      results &&
      results.extractionAttributes &&
      results.extractionAttributes.extractionDefinition
    ) {
      // Added clone deep to avoid side effects to stick with the extractionAttributes
      this.setState({
        extractionDefinition: cloneDeep(
          results.extractionAttributes.extractionDefinition
        ),
      });
    }
  };

  handleExtractDialogCancel = () => {
    //Just need to set the this.extractDefinition to nul to get the diaplog to disappear
    this.setState({ extractionDefinition: null });
  };

  handleExtractDialogComplete = (def: Definition, dimensions: Array<any>) => {
    //Just need to set the this.extractDefinition to nul to get the diaplog to disappear
    const { queryUrl, queryTimeoutSec } = this.props;
    const { criteria, resultsForm } = this.state;

    // This is to prevent side effects from impacting other areas of the app.
    const crit = cloneDeep(criteria);
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    // The form is also part of the criteria, so make sure to set that as well.
    // This is used on the server to do server-side form validations.
    //crit.criteriaForm = criteriaForm;
    crit.resultsForm = resultsForm;
    if (!crit.extractionOpts) {
      crit.extractionOpts = {};
    }
    crit.extractionOpts.definition = def;
    crit.extractionOpts.dimensions = dimensions;

    crit.skip = null;
    crit.limit = null;

    var completionTimeout = 600000;

    if (queryTimeoutSec) {
      completionTimeout = queryTimeoutSec * 1000;
    }

    this.setState({ loadingExport: true });

    request
      .post(queryUrl || "")
      .set("Content-Type", "application/json")
      .send(JSON.stringify(crit))
      .set("Accept", contentType)
      .responseType("blob")
      .timeout({
        response: 600000,
        deadline: completionTimeout,
      })
      .then((response) => {
        let filename = crit.resultsForm.key + ".xlsx";

        let disposition = response["headers"]["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        // file saver module allows blob downloads for IE10+
        saveAs(response.body, filename);
      })
      .catch((err) => {
        const apiErr = new APIError();
        apiErr.type = "http";
        apiErr.message = (err.response || { text: err.toString() }).text;
        this.setState({ error: apiErr, status: "error" });
      })
      .then(() => {
        this.setState({ loadingExport: false });
      });

    this.setState({ extractionDefinition: null });
  };

  renderExtractDialog = () => {
    const { classes }: { classes: ClassNameMap } = this.props;
    // configElement and configElementType need to be added to state and managed
    const { extractionDefinition } = this.state;

    if (!extractionDefinition) {
      return null;
    }

    return (
      <DataExtractDialog
        extractionDefinition={extractionDefinition}
        handleCancel={this.handleExtractDialogCancel}
        handleComplete={this.handleExtractDialogComplete}
      ></DataExtractDialog>
    );
  };

  renderHidableResultsDialog = () => {
    const { classes }: { classes: ClassNameMap } = this.props;
    // configElement and configElementType need to be added to state and managed
    const { hidableResultsOpen, resultsForm } = this.state;

    if (!hidableResultsOpen) {
      return null;
    }

    var hrf = CookieManager.getCookie(
      `hiddenResultsFields|${window.location.pathname}`
    );

    var hiddenFields = [];
    if (hrf) {
      hiddenFields = hrf.split("|");
    }

    return (
      <HidableResultsDialog
        resultsForm={resultsForm}
        hiddenFields={hiddenFields}
        handleCancel={this.handleHidabeResultsDialogCancel}
        handleComplete={this.handleHidabeResultsDialogComplete}
      ></HidableResultsDialog>
    );
  };

  handleHidabeResultsDialogCancel = () => {
    //Just need to set the this.extractDefinition to nul to get the diaplog to disappear
    this.setState({ hidableResultsOpen: false });
  };

  handleHidabeResultsDialogComplete = (hiddenFields: Array<any>) => {
    //set the cookie with the new hidden field array
    CookieManager.setCookie(
      `hiddenResultsFields|${window.location.pathname}`,
      String(hiddenFields.join("|")),
      30
    );
    //Just need to set the this.hidableResultsOpen to false to close the dialog
    this.setState({ hidableResultsOpen: false });
  };

  handleHidableResultsClick = () => {
    this.setState({ hidableResultsOpen: true });
  };

  /*********************************************************************************************
   *
   *                                    Rendering
   *
   * ******************************************************************************************/

  renderSummaryDialog = (): any => {
    const { summaryOperation, results } = this.state;
    let selectedItems: Array<any> = [];

    if (
      results &&
      results.items &&
      results.items.map &&
      results.items.length > 0
    ) {
      selectedItems = results.items.reduce(
        (acc: Array<any>, i: any): Array<any> => {
          if (i["_selected"]) {
            acc.push(i);
          }
          return acc;
        },
        []
      );
    }

    if (summaryOperation && summaryOperation.action) {
      if (summaryOperation.action.onClick) {
        // summaryOperation.action.onClick(selectedItems, this.refreshQueryResults)
        return;
      } else {
        return (
          <SummaryDialog
            title={summaryOperation.action.label}
            onFormComplete={this.handleSummaryOpComplete}
            formSelector={summaryOperation.action.formSelector}
            form={summaryOperation.action.form}
            action={summaryOperation.action}
            items={selectedItems}
          />
        );
      }
    }
  };

  renderSortOptions(): any {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { variant } = this.props;
    const { criteriaForm, sortOption } = this.state;
    if (variant == "single") {
      return null;
    }

    var sortOptions: any = null;
    if (criteriaForm && criteriaForm.sortOptions) {
      sortOptions = (
        <FormControl name="sortByControl" className={classes.sortOptions}>
          <InputLabel shrink htmlFor="sortBy">
            Sort By
          </InputLabel>
          <Select
            id="sortBy"
            value={sortOption || ""}
            onChange={this.onSortChange}
          >
            {<MenuItem value="" />}
            {criteriaForm.sortOptions.map((c: any, idx: number) => {
              return (
                <MenuItem
                  id={"so" + idx}
                  key={idx}
                  value={btoa(JSON.stringify(c))}
                >
                  {c.label + ""}
                  <i
                    className={
                      classes.sortOptionIcon +
                      " fas fa-" +
                      c.icon +
                      " sortOption"
                    }
                  />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      );
    }

    return sortOptions;
  }

  renderResultsList(): any {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {
      gridSpacing,
      customRenderers,
      customMessages,
      variant,
      noResultsText,
      actionsForItemRow,
      reserveRowActionSpace,
      onRowClick,
      suppressExport,
      exportContentType,
      resultsTitleOverride,
      actionsForSelectedItems,
      allowSubscription,
      suppressDashboardCard,
      summaryRenderer,
    } = this.props;
    const {
      results,
      criteria,
      resultsForm,
      loadingExport,
      currentPage,
      pageSize,
      hasExecutedQuery,
      summaryMenuAnchorEl,
      summaryMenuOpen,
      status,
    } = this.state;

    let ct = exportContentType;
    if (!ct) {
      ct = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }

    let allowExtraction = false;
    if (
      results &&
      results.extractionAttributes &&
      results.extractionAttributes.extractionDefinition
    ) {
      allowExtraction = true;
    }

    let allowHidableResults = false;
    if (resultsForm && resultsForm.hidableResults) {
      allowHidableResults = true;
    }

    var tp: any = (
      <div className={classes.listFunctionLine}>
        <Typography className={classes.listTitle} variant="h6">
          {resultsTitleOverride || resultsForm.title}
        </Typography>
        {results && (
          <div className={classes.listFunctions}>
            {allowHidableResults && !loadingExport && (
              <Tooltip
                enterDelay={200}
                id="hidable-results-tooltip"
                placement="top-end"
                title="Customize Visible Fields"
              >
                <IconButton
                  className={classes.listFunctionButton}
                  aria-label="Customize Visible Fields"
                  color="default"
                  onClick={this.handleHidableResultsClick}
                >
                  <i
                    style={{ minWidth: "1rem" }}
                    className={"fa fa-eye-slash"}
                  />
                </IconButton>
              </Tooltip>
            )}

            {allowExtraction && (
              <Tooltip
                enterDelay={200}
                id="extract-tooltip"
                placement="top-end"
                title="Extract Data From Results"
              >
                <IconButton
                  className={classes.listFunctionButton}
                  aria-label="Extract Data From Results"
                  color="default"
                  onClick={this.extractData(ct)}
                >
                  <i style={{ minWidth: "1rem" }} className={"fa fa-cubes"} />
                </IconButton>
              </Tooltip>
            )}

            {!suppressExport && !loadingExport && (
              <Tooltip
                enterDelay={200}
                id="export-tooltip"
                placement="top-end"
                title="Export Results"
              >
                <IconButton
                  className={classes.listFunctionButton}
                  aria-label="Export Results"
                  color="default"
                  onClick={this.exportList(ct)}
                >
                  <i
                    style={{ minWidth: "1rem" }}
                    className={"fa fa-download"}
                  />
                </IconButton>
              </Tooltip>
            )}

            {!suppressExport && loadingExport && (
              <Tooltip
                enterDelay={200}
                id="export-tooltip"
                placement="top-end"
                title="Export Results"
              >
                <IconButton
                  className={classes.listFunctionButton}
                  aria-label="Export Results"
                  color="default"
                  disabled={true}
                  onClick={this.exportList(ct)}
                >
                  <i
                    style={{ minWidth: "1rem" }}
                    className={"fas fa-spinner fa-spin"}
                  />
                </IconButton>
              </Tooltip>
            )}

            {allowSubscription && (
              <Tooltip
                enterDelay={200}
                id="subscribe-tooltip"
                placement="top-end"
                title="Subscribe"
              >
                <IconButton
                  className={classes.listFunctionButton}
                  aria-label="Subscribe"
                  color="primary"
                  onClick={this.handleSubscribeClick}
                >
                  <i className={"fa fa-envelope"} />
                </IconButton>
              </Tooltip>
            )}

            {!suppressDashboardCard && (
              <Tooltip
                enterDelay={200}
                id="dashboard-card-tooltip"
                placement="top-end"
                title="Add to Dashboard"
              >
                <IconButton
                  className={classes.listFunctionButton}
                  aria-label="Add to Dashboard"
                  color="primary"
                  onClick={this.addToDashboard}
                >
                  <i className={"fa fa-address-card"} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
      </div>
    );

    var noResText;
    if (this.props.getNoResultsText) {
      noResText = this.props.getNoResultsText();
    }
    if (!noResText) {
      noResText = noResultsText || "No Results Found";
    }

    var resultsSection: any = null;

    var resultsList: any = (
      <div
        dangerouslySetInnerHTML={{ __html: hasExecutedQuery ? noResText : "" }}
        className={classes.noResultsText + " " + classes.paper}
      ></div>
    );

    // If provided a summary renderer, go ahead and use it
    var summaryArea: any = null;
    if (summaryRenderer) {
      summaryArea = <summaryRenderer data={results} />;
    }

    var pager: any = null;

    var simulationWarning: any = null;

    let selectedItems: Array<any> = [];

    if (
      results &&
      results.items &&
      results.items.map &&
      results.items.length > 0
    ) {
      resultsList = results.items.map((r: any, idx: number): any => {
        // Set an internal index on the row, so that we do not have to use a key from the data
        // Since we are only ever going to be selecting rows that render, we can use the index from the map as the idx
        r["_idx"] = idx;

        var classNames: Array<string> = [`query-list-item-${idx}`];

        if (r["_selected"]) {
          selectedItems.push(r);
          classNames.push(classes.selectedRow, `query-list-item-selected-row`);
        } else if (r["_SummaryActionPolicyMessages"]) {
          classNames.push(classes.summaryActionPolicyMessages);
        } else {
          classNames.push(
            classes.unselectedRow,
            `query-list-item-unselected-row`
          );
        }

        if (idx % 2 == 0) {
          classNames.push(classes.evenRow);
        } else {
          classNames.push(classes.oddRow);
        }

        var onClickAction;
        if (onRowClick) {
          classNames.push(classes.clickableRow);
          onClickAction = this.handleRowClick(r);
        }

        // If the consumer has provided an actionsForSelectedItems function, then we will take that as a signal that the selection should be enabled.
        // Likewise, we will signal the QueryItemView by providing a function for onSelectionChange
        var selFn;
        if (actionsForSelectedItems) {
          selFn = this.onSelectedItemChange;
        }

        var ds = (
          <div key={idx} className={classNames.join(" ")}>
            <QueryItemView
              itemData={r}
              onRowClick={onClickAction}
              actionsForItemRow={actionsForItemRow}
              reserveRowActionSpace={reserveRowActionSpace}
              gridSpacing={gridSpacing}
              customRenderers={customRenderers}
              customMessages={customMessages}
              resultItemDef={resultsForm}
              onSelectionChange={selFn}
              selected={r["_selected"]}
              index={idx}
              criteria={criteria}
            />
          </div>
        );

        return ds;
      });

      if (!variant || variant == "normal") {
        var items: Array<any> = [];
        if (results && results.items) {
          items = results.items;
        }
        pager = (
          <div className={classes.pagerArea}>
            <div className={classes.pager}>
              <Pager
                page={currentPage}
                pageSize={pageSize || 10}
                count={results.totalItemCount || items.length || 0}
                onChangePage={this.handleChangePage}
                disallowScrollTop={this.props.disallowScrollTop}
              />
            </div>
          </div>
        );
      }

      if (results.simulatedData) {
        simulationWarning = (
          <Typography className={classes.simulationWarning} variant="caption">
            <strong>Note:</strong> The data returned in this query is simulated
            and should only be used for illustrative purposes
          </Typography>
        );
      }

      let selectionActionArea: any = null;
      if (actionsForSelectedItems) {
        let actionButton: any = null;
        const actions: any = actionsForSelectedItems(selectedItems);
        var displaySummaryActionButton: boolean = true;
        // Make sure a template and form selector where not provided for any options
        if (actions && actions.length > 0) {
          actions.forEach((a) => {
            if (a.templateSelector && a.formSelector) {
              displaySummaryActionButton = false;
              console.warn(
                "templateSelector and formSelector are mutually exclusive form summary actions, please use one or the other"
              );
            }
          });
        }

        if (displaySummaryActionButton && actions && actions.length > 0) {
          const ab = (
            <Button
              className={"query-list-selection-action"}
              aria-controls="customized-menu"
              aria-haspopup="true"
              variant="contained"
              color="primary"
              onClick={this.handleSummaryMenuClick}
            >
              {selectedItems.length} Selected{" "}
              <i style={{ marginLeft: 10 }} className="far fa-chevron-down" />
            </Button>
          );

          let actionItems: Array<any> = actions.map((a: any, idx: number) => {
            return (
              <StyledMenuItem key={idx}>
                <ListItemText
                  className={classes.hover}
                  onClick={this.handleSummaryMenuItemClick(a)}
                >
                  {a.label}
                </ListItemText>
              </StyledMenuItem>
            );
          });

          if (selectedItems.length > 0) {
            // only show the summary actions if you have items selected
            actionButton = (
              <div>
                {ab}
                <StyledMenu
                  id="customized-menu"
                  className={"query-list-summary-action-menu"}
                  anchorEl={summaryMenuAnchorEl}
                  keepMounted
                  open={summaryMenuOpen}
                  onClose={this.handleSummaryMenuClose}
                  onClick={this.handleSummaryMenuClick}
                >
                  {actionItems}
                </StyledMenu>
              </div>
            );
          }
        }

        selectionActionArea = (
          <div>
            <div className={classes.selectionActionArea}>
              <div className={classes.allSelectors}>
                <div
                  className={classes.select}
                  onClick={this.handleSummarySelectAllClick}
                >
                  <i className={"far fa-check-square " + classes.selector} />{" "}
                  Select All
                </div>
                <div
                  className={classes.unselect}
                  onClick={this.handleSummaryUnselectAllClick}
                >
                  <i className={"far fa-square " + classes.selector} /> Unselect
                  All
                </div>
              </div>
              <div className={classes.selectionCount}></div>
              <div className={classes.selectionAction}>{actionButton}</div>
            </div>
            <div className={classes.summaryActionMessage}>
              {this.props.summaryActionMessage}
            </div>
          </div>
        );
      }

      resultsSection = (
        <Accordion
          defaultExpanded={true}
          className={classes.resultsListSection}
        >
          <AccordionDetails className={classes.paper}>
            <div style={{ width: "100%" }}>
              {summaryArea}
              {tp}
              {simulationWarning}
              {selectionActionArea}
              {status == "paging" && (
                <div
                  style={{
                    top: "50%",
                    left: "50%",
                    zIndex: 9999,
                    position: "fixed",
                  }}
                  className="loader fa fa-3x fa-spin fa-sync"
                ></div>
              )}
              <div
                style={{ opacity: status == "paging" ? 0.3 : 1 }}
                className="result-list-container"
              >
                {resultsList}
              </div>
              {pager}
              {this.props.addNewUrl && (
                <div className={classes.addNewRow}>
                  <Button
                    id="addNewButton"
                    variant="contained"
                    color="secondary"
                    className={classes.buttonAddNew}
                    onClick={this.handleAddNew}
                  >
                    Add New
                  </Button>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
      );
    } else {
      resultsSection = (
        <div className={classes.paper}>
          <div className={classes.noResultsSection + " "}>
            <div
              dangerouslySetInnerHTML={{
                __html: hasExecutedQuery ? noResText : "",
              }}
            />
            <div className={classes.listFunctionLine}></div>
          </div>
          {this.props.addNewUrl && (
            <div className={classes.addNewRowNoResults}>
              <Button
                id="addNewButton"
                variant="contained"
                color="secondary"
                className={classes.buttonAddNew}
                onClick={this.handleAddNew}
              >
                Add New
              </Button>
            </div>
          )}
        </div>
      );
    }

    return resultsSection;
  }

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {
      noResultsText,
      variant,
      gridSpacing,
      customRenderers,
      customMessages,
      actionsForItemRow,
      reserveRowActionSpace,
      resultsTitleOverride,
      criteriaTitleOverride,
      suppressTitle,
      preventCollapse,
    } = this.props;
    const {
      error,
      success,
      status,
      criteria,
      criteriaForm,
      results,
      resultsForm,
      hasExecutedQuery,
      templateRenderer,
    } = this.state;

    var errorView;
    if (error) {
      errorView = (
        <ErrorView classes={{}} error={error} onClose={this.onErrorClose} />
      );
    }

    var successView;
    if (success) {
      successView = (
        <SuccessView
          message={success}
          onClose={this.onSuccessViewClose}
          classes={{}}
        />
      );
    }

    var noResText;
    if (this.props.getNoResultsText) {
      noResText = this.props.getNoResultsText();
    }
    if (!noResText) {
      noResText = noResultsText || "No Results Found";
    }

    switch (status) {
      case "loading":
        return (
          <div className={classes.container}>
            <LoadingView title={this.state.loadingText} classes={{}} />
          </div>
        );
        break;

      case "fatal":
        // TODO: Increase the quality of this error, and since this is goping to be a VERY commonly used methods for detecting and debugging issues on the back end,
        // it may be worth some time really focussing on the implementation here.
        return (
          <div className={classes.container}>
            <ErrorView error={error} mode="inline" />
          </div>
        );
        break;

      default:
        // We will check for not results and set the section value accordingly if results are undefined or empty
        // Undefined results will simply show nothing.  This is the case prior to execution.
        var resultsSection: any = null;
        if (results) {
          if (
            !results.items ||
            !results.items.length ||
            results.items.length == 0
          ) {
            resultsSection = (
              <div className={classes.resultsSection}>
                {hasExecutedQuery ? noResText : ""}
              </div>
            );
          }
        }

        var policyMessages: any = null;

        if (results && results.policyMessages) {
          policyMessages = results.policyMessages;
        }
        const criteriaSection: any = (
          <DefinitionSection
            preventCollapse={preventCollapse}
            data={criteria}
            definition={criteriaForm}
            path={""}
            onChangeAtPath={this.handleChangeAtPath}
            policyMessages={policyMessages}
            titleOverride={criteriaTitleOverride}
            gridSpacing={gridSpacing || 1}
            customRenderers={customRenderers}
            customMessages={customMessages}
            onAccessRootData={this.handleAccessRootData}
            embedded={true}
            suppressTitle
            onEvaluateConditional={this.props.onEvaluateConditional}
            supressSectionStatusIcon={this.props.supressSectionStatusIcon}
          />
        );

        var sortOptions = this.renderSortOptions();
        var buttonBar = (
          <div className={classes.buttonBar}>
            <div className={classes.sortArea}>{sortOptions}</div>
            <div className={classes.buttonArea}>
              <Button
                id="clearButton"
                variant="contained"
                color="default"
                className={classes.buttonClear}
                onClick={this.handleClearClick}
              >
                {this.props.clearButtonText || "Clear"}
              </Button>
              <Button
                id="submitButton"
                variant="contained"
                color="primary"
                type="submit"
                className={classes.buttonSubmit}
                disabled={status == "searching" || status == "loading"}
                onClick={this.handleSubmit}
                
              >
                {this.props.submitButtonText || "Submit"}
              </Button>
            </div>
          </div>
        );
        switch (variant) {
          case "single":
            var tp: any = null;

            if (results && results.items) {
              if (results.items && results.items.length > 0) {
                // This is what we show if we have results
                var classNames: Array<string> = [classes.resultsSection];

                var onClickAction;
                if (this.props.onRowClick) {
                  classNames.push(classes.clickableRow);
                  onClickAction = this.handleRowClick(results.items[0]);
                }

                resultsSection = (
                  <div className={classNames.join(" ")}>
                    <QueryItemView
                      itemData={results.items[0]}
                      onRowClick={onClickAction}
                      resultsTitleOverride={resultsTitleOverride}
                      actionsForItemRow={actionsForItemRow}
                      reserveRowActionSpace={reserveRowActionSpace}
                      gridSpacing={gridSpacing}
                      customRenderers={customRenderers}
                      customMessages={customMessages}
                      resultItemDef={resultsForm}
                      selected={false}
                      criteria={criteria}
                    />
                  </div>
                );
              }
              if (resultsForm.title) {
                tp = (
                  <Typography className={classes.listTitle} variant="h6">
                    {resultsTitleOverride || resultsForm.title}
                  </Typography>
                );
              }
              var buttonBar = (
                <div className={classes.buttonBar}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonSubmit}
                    onClick={this.handleReset}
                  >
                    Back
                  </Button>
                </div>
              );
            } else {
              resultsSection = criteriaSection;
              tp = (
                <Typography className={classes.listTitle} variant="h6">
                  {criteriaForm.title}
                </Typography>
              );
            }

            return (
              <div className={classes.container}>
                {errorView}
                {successView}
                <Paper className={classes.criteriaSection}>
                  {tp}
                  {resultsSection}
                  {buttonBar}
                </Paper>
              </div>
            );

            break;

          default:
            // Render the summary dialog, if appropriate
            var sd: any = null;
            sd = this.renderSummaryDialog();

            // Render the Dashboard Card Management Dialog, if appropriate
            var dbc: any = null;
            if (!sd) {
              // Only allow this dialog if the summary dialog is not showing
              dbc = this.renderDashboardCardDialog();
            }

            // Render the Data Extraction Management Dialog, if appropriate
            var ebc: any = null;
            if (!sd && !dbc) {
              // Only allow this dialog if the no other dialogs are showing
              ebc = this.renderExtractDialog();
            }

            // Render the Hidable Results Dialog, if appropriate
            var hrd: any = null;
            if (!sd && !dbc && !ebc) {
              // Only allow this dialog if the no other dialogs are showing
              hrd = this.renderHidableResultsDialog();
            }

            // Render the results
            resultsSection = this.renderResultsList();

            if (suppressTitle) {
              // All together now.
              return (
                <div className={classes.container}>
                  {errorView}
                  {successView}

                  {!this.props.suppressCriteriaView && (
                    <Accordion
                      defaultExpanded={true}
                      className={classes.criteriaSection}
                    >
                      <AccordionDetails className={classes.paper}>
                        <form
                          style={{ width: "100%" }}
                          onSubmit={this.onFormSubmit.bind(this)}
                        >
                          {criteriaSection}
                          {buttonBar}
                        </form>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  {status != "searching" && resultsSection}
                  {status == "searching" && (
                    <LoadingView title={this.state.loadingText} classes={{}} />
                  )}
                  {hrd}
                  {ebc}
                  {dbc}
                  {sd}
                </div>
              );
            } else {
              // All together now.
              return (
                <div className={classes.container}>
                  {errorView}
                  {successView}
                  {templateRenderer}
                  {!this.props.suppressCriteriaView && (
                    <Accordion
                      defaultExpanded={true}
                      className={classes.criteriaSection}
                    >
                      <AccordionSummary
                        className={classes.paper}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <Typography
                          className={classes.sectionTitle}
                          variant="h6"
                        >
                          {criteriaTitleOverride || criteriaForm.title}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.paper}>
                        <form
                          style={{ width: "100%" }}
                          onSubmit={this.onFormSubmit.bind(this)}
                        >
                          {criteriaSection}
                          {buttonBar}
                        </form>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  {status != "searching" && resultsSection}
                  {status == "searching" && <LoadingView classes={{}} />}
                  {hrd}
                  {ebc}
                  {dbc}
                  {sd}
                </div>
              );
            }

            break;
        }
    }
  }
}

function downloadBlob(blob, filename) {
  // Create an object URL for the blob object
  const url = URL.createObjectURL(blob);

  // Create a new anchor element
  const a = document.createElement("a");

  // Set the href and download attributes for the anchor element
  // You can optionally set other attributes like `title`, etc
  // Especially, if the anchor element will be attached to the DOM
  a.href = url;
  a.download = filename || "download";

  // Click handler that releases the object URL after the element has been clicked
  // This is required for one-off downloads of the blob content
  const clickHandler = () => {
    setTimeout(() => {
      //URL.revokeObjectURL(url);
      //a.removeEventListener('click', clickHandler);
    }, 150);
  };

  // Add the click event listener on the anchor element
  // Comment out this line if you don't want a one-off download of the blob content
  a.addEventListener("click", clickHandler, false);

  // Programmatically trigger a click on the anchor element
  // Useful if you want the download to happen automatically
  // Without attaching the anchor element to the DOM
  // Comment out this line if you don't want an automatic download of the blob content
  a.click();

  // Return the anchor element
  // Useful if you want a reference to the element
  // in order to attach it to the DOM or use it in some other way
  return a;
}

export default withStyles(styles)(QueryList);
